export const GET_TYPE_PARAMETERS = 'GET_TYPE_PARAMETERS';
export const GET_TYPE_PARAMETERS_SUCCESS = 'GET_TYPE_PARAMETERS_SUCCESS';
export const GET_TYPE_PARAMETERS_ERROR = 'GET_TYPE_PARAMETERS_ERROR';
